// Helper function is used to get current active promotions and return specific promtion details such as:
// - Name
// - type ( product/package )
// - Promotional content ( Description etc )
// - network image/logo link(s)
export function getActivePromotionDetails( id, type ) {

    if( type === "product" ) {
        switch( id ) {
            case 1: return {
                name: "Non-Executive Directors Profile",
                type: 1,
                content: "Content for Non-Executive Directors Profile",
                img: "/img/link",
            };
            case 2: return {
                name: "The Consultant Hub Profile",
            };
            case 3: return {
                name: "Finance Director Profile",
            };
            case 4: return {
                name: "Women Directors Profile",
            };
            case 5: return {
                name: "",
            };
            case 6: return {
                name: "",
            };
            case 7: return {
                name: "",
            };
            case 8: return {
                name: "",
            };
            case 9: return {
                name: "",
            };
            case 10: return {
                name: "",
            };
            case 11: return {
                name: "",
            };
            case 12: return {
                name: "",
            };
            case 13: return {
                name: "",
            };
            case 14: return {
                name: "",
            };
            case 15: return {
                name: "",
            };
            case 16: return {
                name: "",
            };
            case 17: return {
                name: "",
            };
            default: return null;
        }
    }
    else if( type === "package" ) {
        switch( id ) {
            case 1: return {
                name: "",
            };
            case 2: return {
                name: "The Consultant Hub Profile",
            };
            case 3: return {
                name: "Finance Director Profile",
            };
            case 4: return {
                name: "Women Directors Profile",
            };
            case 5: return {
                name: "",
            };
            case 6: return {
                name: "Package Example",
                type: 2,
                content: "Example Package Content",
            };
            case 7: return {
                name: "",
            };
            case 8: return {
                name: "",
            };
            case 9: return {
                name: "",
            };
            case 10: return {
                name: "",
            };
            case 11: return {
                name: "",
            };
            case 12: return {
                name: "",
            };
            case 13: return {
                name: "",
            };
            case 14: return {
                name: "",
            };
            case 15: return {
                name: "",
            };
            case 16: return {
                name: "",
            };
            case 17: return {
                name: "",
            };
            default: return null;
        }
    }


}

// Investor Director Profile
// Non-Executive Directors Jobs Board
// The Consultant Hub Jobs Board
// Finance Director Jobs Board
// Women Directors Jobs Board
// Investor Director Jobs Board
// Non-Executive Directors Forum Access
// The Consultant Hub Forum Access
// Finance Director Forum Access
// Women Directors Forum Access
// Investor Director Forum Access
// On-Demand Training
// Business Transformation
// Business Transformation Premium
// Professional Documents
// News
// Interactive Webinars
// Events


// WEBPACK FOOTER //
// src/client/helpers/promotionHelpers.js